export default __webpack_public_path__ + "static/media/loadingPuntos.5e54d658.svg";